<template lang="pug">
  .dashboard
    loading
    messageview
    //- header
    .nav-md(scroll='auto')
      .container.body
        .top_nav
          .nav_menu
            nav
              #navbar.navbar-collapse.collapse
                img.logo(src='../../assets/racooo_logo_indigo.png')
                ul.nav.navbar-nav.navbar-right
                  li.dropdown
                    a.dropdown-toggle.headermenu(href='#', data-toggle='dropdown', role='button', aria-haspopup='true', aria-expanded='false')
                      | {{ $store.user.contractor_name + ' ' + $store.user.name }}さん
                    ul.dropdown-menu
                      li(v-show='$store.user.admin == 1')
                        router-link(to='/dashboard/adminsettings')
                          i.fa.fa-cog(area='true') 　管理者設定
                      li
                        a(href='#')
                          i.fa.fa-question-circle(area-hidden='true') 　ヘルプ
                      li
                        router-link(to='/auth/login')
                          i.fa.fa-sign-out(aria-hidden='true') 　ログアウト
        .main_container
          //sidemenu
          .col-md-3.left_col
            .left_col.scroll-view
              .navbar.nav_title(style='border: 0;')
                a.site_title(href='#')
                  i.fa.fa-envelope-o.fa-fw(aria-hidden='true')
                  span Racooo
              .clearfix
              #sidebar-menu.main_menu_side.hidden-print.main_menu
                .profile.clearfix
                  .profile_info
                    span ようこそ
                    p {{ $store.user.name }}さん
                .menu_section
                  ul.nav.side-menu
                    li(v-bind:class='{selected: selectedMessage}')
                      router-link(to='/dashboard/information')
                        i.fa.fa-envelope(aria-hidden='true')
                        |  メッセージ
                    li(v-bind:class='{selected: selectedForm}')
                      router-link(to='/dashboard/forms')
                        i.fa.fa-list-alt(aria-hidden='true')
                        |  フォーム設定
              .sidebar-footer.hidden-small
                router-link(to='/dashboard/usersettings' data-toggle='tooltip', data-placement='top', title='個人設定')
                  i.fa.fa-cog(aria-hidden='true')
                router-link(to='/dashboard/auth/login' data-toggle='tooltip', data-placement='top', title='ログアウト')
                  i.fa.fa-sign-out(aria-hidden='true')
        router-view
        footer-row
</template>

<script>
import $ from 'jquery'
import bus from '@/service/EventBus'
import messageview from '@/components/MessageView'

export default {
  data () {
    return {
      selectedMessage: false,
      selectedForm: false
    }
  },
  components: {
    messageview
  },
  mounted () {
    $('[data-toggle=tooltip]').tooltip()
    // EventBusからグローバルに制御を受け取る
    let self = this
    bus.$on('select_menu', (menuId) => {
      self.selectedForm = false
      self.selectedMessage = false
      if (menuId === 'message') {
        self.selectedMessage = true
      }
      if (menuId === 'form') {
        self.selectedForm = true
      }
    })

    // default
    this.selectedMessage = true
  }
}
</script>

<style lang="stylus">
//logo
.logo
  width: 135px
  padding: 4px 0

//sidebar
.sidebar-footer
  a
    width: 50%
    color: #fff
    padding: 13px 0
.page-title .title_left h2
  padding: 40px 0 15px
  font-size: 20px
.profile_info
  width: 100%
  padding: 10px 13px
  p
    color:#fff
//header&sidebar
.nav-md, .container.body, .col-md-3, .left_col
  display: block
li.dropdown
  font-size: 13px !important
//全共通
.x_panel
  padding:20px 25px 10px
//auth以外共通
ul#myTab
  margin-top: 45px
select.searchselect.selectitems
  padding: 2px 0px 4px 3px
input
  &[type="radio"], &[type="checkbox"]
    margin: 2px 5px 0 0
    width: 17px
    height: 17px
//radiobutton
.radio02-input
  display: none
  + label
    padding-left: 20px
    position: relative
    margin-right: 20px
    cursor: pointer
    &:before
      content: ""
      display: block
      position: absolute
      top: 1px
      left: 1px
      width: 15px
      height: 15px
      border: 1px solid #999
      border-radius: 50%
  &:checked + label
    color: #1abc9c
    &:after
      content: ""
      display: block
      position: absolute
      top: 3px
      left: 3px
      width: 11px
      height: 11px
      background: #1abc9c
      border-radius: 50%
//checkbox
.checkbox01-input
  display: none
.checkbox01-parts
  padding-left: 20px
  position:relative
  margin-right: 20px
.checkbox01-parts::before
  content: ""
  display: block
  position: absolute
  top: 1px
  left: 1px
  width: 15px
  height: 15px
  border: 1px solid #999
  border-radius: 4px
.checkbox01-input:checked + .checkbox01-parts
  color: #1abc9c
.checkbox01-input:checked + .checkbox01-parts::after
  content: ""
  display: block
  position: absolute
  top: -1px
  left: 7px
  width: 7px
  height: 14px
  transform: rotate(40deg)
  border-bottom: 3px solid #1abc9c
  border-right: 3px solid #1abc9c
//エラー等メッセージ表示

//forms,informartion,accounts table
.datatable
  th.icon
    width: 10%
  td
    vertical-align: middle
    padding: 5px !important
  .icontablebutton
    text-align: center
  .btn.btn-app.tableicon
    padding: 5px 15px
    margin: 0
    min-width: 27px
    height: 29px
    border: 1px solid #ddd
    background-color: #fafafa
    border-radius: 3px
  .fa
      font-size: 14px !important
  .fa-fw
    1em !important
  .fa.fa-times-circle
    color: white
//forms, formedit
.formpage
  input[type='checkbox']
    transform: scale(1.4)
.btn-primary:hover
.btn-primary:active
.btn-primary.active, .open > .dropdown-toggle.btn-primary
  background-color: #34495e
.top_nav .navbar-right li
  font-size: 15px
.site_title
  padding-left: 3px
  i
    border: none
.nav_menu
	padding: 15px 0px 15px 15px
	margin-bottom: 0
	position: fixed
	z-index: 100
//table共通
th
  text-align: center
//usersettings, adminsettings
.settingpage
  .customsmallbutton
    padding: 6px 10px
    font-size: 15px
  .btn-link
    font-size: 15px !important
.tdcenter
  text-align: center
#pager
  float: right
//全共通
.nav-md .container.body
  .right_col
    min-height: calc(100vh - 53px) !important
    padding: 10px 40px 0
    margin-left: 230px
  overflow: hidden
  .col-md-3.left_col
    min-height: 100%
.main_menu .fa
  width: 35px
  font-size: 20px
.nav.side-menu > li
  > a
    font-size: 15px
    transition: inherit
    &:hover
      text-shadow: rgba(0, 0, 0, 0.25) 0 -1px 0
      box-shadow: rgba(0, 0, 0, 0.25) 0 1px 0, inset rgba(255, 255, 255, 0.16) 0 1px 0
  &:hover
    border-right: 5px solid #1ABB9C
ul.bar_tabs
  background: none
ul.bar_tabs>li.active
  border-right: 6px solid #1abb9c
//message, messagebox
.searchbox
  padding: 0px 25px 10px
  .x_title
    padding: -1px 5px 30px
    border-bottom: 1px solid #E6E9ED
    margin-bottom: 20px
    h4
      margin-bottom: 0
  #freesearch
    height: 28px
  #reservation
    height: 28px
    border-radius: 3px
    width: 180px !important
  .x_content
    margin-top: -20px
    .customsmallbutton
      margin-top: -85px
  .searchitem
    display: inline-block
  .form-horizontal
    padding: 0
  .selectitems
    padding: 0px 10px
  .buttons
    text-align: center
    margin-bottom: 0
    .customsmallbutton
      margin-top: 0
      padding: 6px 10px
      font-size: 12px
  @media (min-width: 1400px)
    .col-xs-3
      padding-left: 80px
    #freesearch
      width: 250px
    .charge
      padding-left: 30px
// .allmaildisplay
//   font-size: 14px !important

select
  border-radius: 3px !important
  -webkit-border-radius: 20px
  -moz-border-radius: 20px
  color: #808080
textarea
  border-radius: 3px
.help-block
  color: #2A3F54
ul.bar_tabs>li.active a
  border-bottom-color: transparent
.tooltip-inner
  max-width: 100%

.danger
  border: 2px solid #d9534f
  background: #ffa6a4
.warning
  border: 2px solid #f0ad4e
  background: #ffd79c
.success
  border: 2px solid #0bbb98
  background: #86efda

ul.nav.side-menu li.selected
  border-right: 5px solid #1abb9c
  text-shadow: rgba(0,0,0,0.25) 0 -1px 0
  box-shadow: rgba(0,0,0,0.25) 0 1px 0, inset rgba(255,255,255,0.16) 0 1px 0

.bootstrap-tagsinput
  width: 90%
  resize: vertical
.tag
  display: inline !important
  float: none !important
.tag:after
  border-left: none
</style>



// WEBPACK FOOTER //
// Layout.vue?2b0b32ea